export const EM_DASH = '\u2014';
